<template>
  <van-nav-bar :title="pageTitle"
               :left-text="leftArrow ? leftText : ''"
               :left-arrow="leftArrow"
               :right-text="rightText"
               @click-left="onClickLeft"
               @click-right="onClickRight"
               :fixed="fixed"
               z-index="99">
    <slot></slot>
  </van-nav-bar>
</template>

<script>
export default {
  name: 'TopNav',
  props: {
    pageTitle: {
      type: String,
      default: '标题'
    },
    leftText: {
      type: String,
      default: ''
    },
    leftArrow: {
      type: Boolean,
      default: true
    },
    rightText: {
      type: String,
      default: ''
    },
    fixed: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onClickLeft() {
      this.$emit('click-left')
    },
    onClickRight() {
      this.$emit('click-right')
    }
  }
}
</script>

<style lang="less" scoped></style>
